module.exports = __webpack_public_path__ + "static/media/Resolution.25901324.pdf";